/**
 * Usonian CSS > Settings > Global
 */

export const borderRadius = '0.25rem';
export const borderRadiusSmall = '10px';
export const borderRadiusMedium = '12px';
export const borderRadiusLarge = '0.875rem';
export const borderRadiusLargest = '1.5rem';

export const fontWeightLight = '200';
export const fontWeightMedium = '400';
export const fontWeightHeavy = 'bold';

export const fontSizeBase = '1rem';
export const fontSizeLarge = '1.25rem';
export const fontSizeLarger = '1.5rem';
export const fontSizeLargest = '3rem';
export const fontSizeSmall = '0.875rem';
export const fontSizeSmaller = '0.64rem';

export const transitionDuration = '300ms';
export const transitionDurationFast = '200ms';
export const transitionDurationSlow = '500ms';

/* Base settings */

export const baseFontFamily = 'Nunito, system, -apple-system, BlinkMacSystemFont, sans-serif';
export const baseFontSize = '16px';
export const baseLineHeight = '1.5';

export const baseSpace = '1rem';

export const baseMaxWidth = '1280px';

export const iconSizes = {
  small: '0.75rem',
  base: '1.25rem',
  large: '1.5rem',
  larger: '2.25rem',
  largest: '4rem',
};

export const pageHeadingSize = '1.5rem';

export const breakPoints = ['700px', '1024px', '1200px'];
